import { TableRowActionsModel } from "./list.interface";

const noActions: TableRowActionsModel = {
    edit: false,
    delete: false,
    view: false,
    download: false,
    verify: false,
    add: false,
    refresh: false,
    mail: false,
    approve: false,
    deny: false,
    schedule: false,
    select: false,
    unmask: false,
    deactivate: false,
    editHistory: false,
    auditHistory: false,
    updateCap: false
}

export class TableRowActions {
    edit  = false;
    delete  = false;
    view  = false;
    download  = false;
    verify = false;
    add = false;
    refresh = false;
    mail = false;
    deny = false;
    approve = false;
    schedule = false;
    select = false;
    unmask = false;
    deactivate = false;
    editHistory  = false;
    auditHistory  = false;
    updateCap  = false;
    constructor(actions?: Partial<TableRowActionsModel>) {
        let newActions = { ...noActions }
        if (actions) newActions = { ...newActions, ...actions };

        this.edit = newActions.edit;
        this.delete = newActions.delete;
        this.view = newActions.view;
        this.download = newActions.download;
        this.verify = newActions.verify;
        this.add = newActions.add;
        this.refresh = newActions.refresh;
        this.mail = newActions.mail;
        this.approve = newActions.approve;
        this.deny = newActions.deny;
        this.schedule = newActions.schedule;
        this.select = newActions.select;
        this.unmask = newActions.unmask;
        this.deactivate = newActions.deactivate;
        this.editHistory = newActions.editHistory;
        this.auditHistory = newActions.auditHistory;
        this.updateCap = newActions.updateCap;
    }
}